import { Box, styled } from "@mui/material"
import { AsideSectionAreas } from "../AsideSection"

export const AsideSectionTitleArea = styled(Box)(() => ({
  gridArea: AsideSectionAreas.asideHeader,
}))
